import { SelectBox } from '@ridi/rsg';
import classNames from 'classnames';
import { createElement } from 'react';

var Order = function (props) {
    var orders = props.orders, isMobile = props.isMobile, _a = props.dividerType, dividerType = _a === void 0 ? 'pipe' : _a, makeURL = props.makeURL, activeOrderType = props.activeOrderType, onOrderChange = props.onOrderChange, component = props.component;
    var LinkButton = component || 'a';
    if (isMobile) {
        return (createElement("div", { className: "RUIOrder" },
            createElement(SelectBox, { title: "\uC815\uB82C\uAE30\uC900 \uC120\uD0DD", className: "RUIOrder_SelectBox", renderOutline: true, onChange: onOrderChange }, orders.map(function (order) { return (createElement("option", { key: order.type, value: order.type, selected: activeOrderType === order.type }, order.name)); }))));
    }
    return (createElement("div", { className: classNames('RUIOrder', "RUIOrder-" + dividerType) },
        createElement("ul", null, orders.map(function (order) { return (createElement("li", { key: order.name, className: classNames('RUIOrder_Item', { active: order.type === activeOrderType }) },
            createElement(LinkButton, { className: "RUIOrder_Button", href: makeURL(order) }, order.name))); }))));
};

export { Order };
//# sourceMappingURL=Order.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/Order.js